import { DashboardNodeType } from '../core/node.type';

export class CSSClass {
  static readonly NODE = 'ak-dashboard-node';
  static readonly NODE_DRAG_PREVIEW = `${CSSClass.NODE}-preview`;
  static readonly NODE_BREADCRUMBS = `${CSSClass.NODE}-breadcrumbs`;
  static readonly DROP_SLOT = `${DashboardNodeType.CONTAINER}-dropslot`;
  static readonly NODE_TOOLBAR = `${CSSClass.NODE}-toolbar`;
  static readonly NODE_SELECTED = `${CSSClass.NODE}-selected`;
  static readonly NODE_WRAPPER = `${CSSClass.NODE}-wrapper`;
  static readonly NODE_CONTENT = `${CSSClass.NODE}-content`;
  static readonly DASHBOARD_WRAPPER = 'ak-dashboard-wrapper';
  static readonly CONTAINER = DashboardNodeType.CONTAINER;
  static readonly CONTAINER_TOOLBAR = `${DashboardNodeType.CONTAINER}-toolbar`;
  static readonly CONTAINER_GRID = 'container-grid-visible';
  static readonly EDIT_MODE = 'ak-dashboard-editmode';
  static readonly MOUSE_ENTER = 'mouseenter';
  static readonly MOUSE_OVER = 'mouseover';
  static readonly SELECTED = 'selected';
  static readonly DRAG_ENTER = 'dragenter';
  static readonly DRAGGING = 'dragging';
}

export enum Attribute {
  DRAGGABLE = 'draggable',
}

export class ViewSelector {
  static readonly DRAG_PREVIEW = 'dragPreview';
  static readonly BREADCRUMBS = 'breadcrumbs';
  static readonly COMPONENT = 'componentRef';
  static readonly NAVIGATION = 'navigationRef';
  static readonly COLLAPSE = 'collapseRef';
  static readonly CONTAINER = 'container';
  static readonly CONTENT = 'content';
  static readonly WRAPPER = 'wrapper';
  static readonly TOOLBAR = 'toolbar';
}

export const SYSTEM_CLASSES = [
  DashboardNodeType.CONTAINER,
  DashboardNodeType.NAVIGATION,
  DashboardNodeType.LAYOUT,
  DashboardNodeType.COLLAPSE,
  DashboardNodeType.WIDGET,
  CSSClass.NODE_BREADCRUMBS,
  CSSClass.NODE_TOOLBAR,
  CSSClass.NODE,
  CSSClass.NODE_WRAPPER,
  CSSClass.DASHBOARD_WRAPPER,
  CSSClass.CONTAINER,
  CSSClass.DROP_SLOT,
  CSSClass.DRAG_ENTER,
  CSSClass.DRAGGING,
  CSSClass.EDIT_MODE,
  CSSClass.MOUSE_ENTER,
  CSSClass.NODE_SELECTED,
  CSSClass.SELECTED,
  CSSClass.MOUSE_OVER,
  CSSClass.NODE_CONTENT,
];

export class DOMConstant {
  public static readonly OPACITY = 'opacity';
  public static readonly DRAGGABLE = 'draggable';
  public static readonly CURSOR = 'cursor';
}

export enum Cursor {
  MOVE = 'move',
  GRAB = 'grab',
  COPY = 'copy',
}

export enum DataTransferType {
  PLAIN_TEXT = 'text/plain',
  TEXT = 'text',
}

export enum DOMEvent {
  MOUSE_OVER = 'mouseover',
  MOUSE_LEAVE = 'mouseleave',
  DRAG_LEAVE = 'dragleave',
  DRAG_START = 'dragstart',
  DRAG_ENTER = 'dragenter',
  DRAG_OVER = 'dragover',
  DRAG_END = 'dragend',
  CLICK = 'click',
  DROP = 'drop',
}

export interface DndEvent {
  stopPropagation(): void;
  preventDefault(): void;
  dataTransfer: DataTransfert;
}

interface DataTransfert {
  getData(type: string): any;
  setData(type: string, value: any): void;
  setDragImage(image: Element, x: number, y: number): void;
}
